import React from "react";
import Heading from "./Heading";
import { pizza } from "./pizzaData";
import { specialFlavour } from "./specialFlavourData";
function Pizza() {
  return (
    <>
      <a href="#" id="pizza"></a>
      <div className="w-full p-4 my-5 h-fit font-fancy">
        <Heading heading="Pizza" />
        {pizza.map((pizza) => {
          return (
            <React.Fragment key={pizza.id}>
              <div className="p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-lg font-bold">{pizza.name}</h3>
                <p className="text-base">{pizza.description}</p>
                <div className="flex justify-start gap-10">
                  <div className="font-semibold">
                    <p>Small</p>
                    <p className="pl-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                      {pizza.priceS}
                    </p>
                  </div>
                  <div className="font-semibold">
                    <p>Medium</p>
                    <p className="pl-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                      {pizza.priceM}
                    </p>
                  </div>
                  <div className="font-semibold">
                    <p>Large</p>
                    <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[2px]">
                      {pizza.priceL}
                    </p>
                  </div>
                  {pizza.priceXL && (
                    <div className="font-semibold">
                      <p>XL</p>
                      <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[2px]">
                        {pizza.priceXL}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
        })}

        {/* ------------>Special Flavours */}
        <Heading heading="Special Flavours" />
        {specialFlavour.map((specialPizza) => {
          return (
            <React.Fragment key={specialFlavour.id}>
              <div className="p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
                <h3 className="text-lg font-bold">{specialPizza.name}</h3>
                <div className="flex justify-start gap-10">
                  <div className="font-semibold">
                    <p>Medium</p>
                    <p className="pl-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                      {specialPizza.priceM}
                    </p>
                  </div>
                  <div className="font-semibold">
                    <p>Large</p>
                    <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[1px]">
                      {specialPizza.priceL}
                    </p>
                  </div>
                  {specialPizza.priceXL && (
                    <div className="font-semibold">
                      <p>XL</p>
                      <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[1px]">
                        {specialPizza.priceXL}
                      </p>
                    </div>
                  )}
                </div>
              </div>
            </React.Fragment>
          );
        })}

        {/* ---------->Extra Toppings */}
        <Heading heading="Extra Topping" />
        <div className="p-4 my-5 shadow-2xl shadow-gray-700 drop-shadow-xl rounded-2xl ">
          <div className="flex justify-start gap-10">
            <div className="font-semibold">
              <p>Small</p>
              <p className="pl-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                100
              </p>
            </div>
            <div className="font-semibold">
              <p>Medium</p>
              <p className="pl-1 font-extrabold rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500">
                180
              </p>
            </div>
            <div className="font-semibold">
              <p>Large</p>
              <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[2px]">
                250
              </p>
            </div>
            <div className="font-semibold">
              <p>XL</p>
              <p className="rounded-r-full bg-gradient-to-tr from-yellow-200 to-yellow-500 font-extrabold pl-[2px]">
                350
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Pizza;
